export var delay = function (miliseconds) {
    return new Promise(function (resolve) { return setTimeout(resolve, miliseconds); });
};
//# sourceMappingURL=delay.js.map